import { computed, Directive, input } from '@angular/core';
import { sonaHlm } from '@sona/angular-util-common';
import { BrnDialogDescriptionDirective } from '@spartan-ng/ui-dialog-brain';

import type { ClassValue } from 'clsx';

@Directive({
    selector: '[hlmDialogDescription]',
    standalone: true,
    host: {
        '[class]': '_computedClass()'
    },
    hostDirectives: [ BrnDialogDescriptionDirective ]
})
export class HlmDialogDescriptionDirective {
    public readonly userClass = input<ClassValue>('', { alias: 'class' });
    protected _computedClass = computed(() => sonaHlm('tw-text-sm tw-text-muted-foreground tw-mb-0', this.userClass()));
}
